import {
  MeasuringStrategy,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';

export const bulkUploadDndMeasuring = {
  droppable: {
    strategy: MeasuringStrategy.WhileDragging,
  },
};

export const bulkUploadDndAutoScroll = {
  threshold: { x: 0.12, y: 0.12 },
  acceleration: 10,
};

export const useBulkUploadDndSensors = () =>
  useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 8 } }),
  );
